import styled from 'styled-components';
import TooltipBubble from './TooltipBubble';

const TooltipLeft = styled(TooltipBubble)`
  top: ${({ locationTop }) => locationTop || '50%'};
  right: 100%;
  padding-right: 9px;
  transform: translateY(-50%);

  &::after {
    border-left: 9px solid rgba(0, 0, 0, 0.7);
    border-top: 9px solid transparent;
    border-bottom: 9px solid transparent;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
  }
`;

export default TooltipLeft;
